import ImmutableRenderMixin from 'react-immutable-render-mixin';

import React from 'react';

/** In place of using ImmutableRenderMixin directly as mixins are
  * getting obsolete.
  * For documentation of the mixin, see
  * https://www.npmjs.com/package/react-immutable-render-mixin
  */
class ImmutableRenderComponent extends React.Component {
  constructor(props) {
    super(props);
    this.shouldComponentUpdate = ImmutableRenderMixin.shouldComponentUpdate;
  }
}

export default ImmutableRenderComponent;
